import { render, staticRenderFns } from "./LinkToRepository.vue?vue&type=template&id=42e6beb9&"
import script from "./LinkToRepository.vue?vue&type=script&lang=js&"
export * from "./LinkToRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports